import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

@Injectable()
export class HasCandidateModalQueryParamGuard implements CanActivate {
  canActivate(next: ActivatedRouteSnapshot): boolean {
    return !!next.queryParams['edit-candidate'];
  }
}
